export const translations = {
  es: {
    nav: {
      experience: "Experiencia",
      menu: "Menú",
      host: "Anfitrión",
      reviews: "Reseñas",
      location: "Ubicación",
      book: "Reservar",
      admin: "Admin",
      home: "Inicio",
      faq: "Preguntas frecuentes",
      pages: "Páginas",
      sections: "La experiencia",
      open_menu: "Abrir menú",
      close_menu: "Cerrar menú",
      whatsapp: "Escribinos por WhatsApp",
    },
    hero: {
      overline: "Palermo Soho · Buenos Aires",
      title_1: "Asados en Palermo",
      title_2: "al calor del fuego.",
      subtitle:
        "Vivís un asado argentino auténtico con Diego: brasa, Malbec y cortes premium en una mesa íntima de Palermo Soho.",
      cta: "Reservar experiencia",
      secondary: "Descubrir el menú",
      rating_caption: "170+ reseñas · 4.99 promedio",
    },
    experience: {
      overline: "La experiencia",
      title: "Cinco momentos. Una sola noche inolvidable.",
      subtitle:
        "Un recorrido de 2.5 horas por los rituales del asado argentino — de la recepción con Malbec al dulce final.",
      steps: [
        {
          title: "Recepción con Malbec",
          body:
            "Te recibimos con una copa de nuestro Malbec de guarda. Empieza la conversación, baja el ritmo, arrancan las brasas.",
        },
        {
          title: "Clase de asado",
          body:
            "Diego comparte técnicas, historia y cultura del asado. Podés acercarte a la parrilla y participar de cada corte.",
        },
        {
          title: "Provoleta & entradas",
          body:
            "Provoleta fundida al punto justo, choripán artesanal y vegetales a la parrilla.",
        },
        {
          title: "Los cortes",
          body:
            "Matambre de cerdo, ojo de bife y asado de tira. Todos los acompañamientos, servidos sin apuro.",
        },
        {
          title: "Postre & café",
          body: "Panqueque con dulce de leche acompañado de un espresso. Sobremesa tranquila.",
        },
      ],
    },
    host: {
      overline: "El anfitrión",
      title: "Diego",
      tagline: "Argentine barbecue specialist · 20 años de catering",
      body:
        "Viví en Venezuela, México, Inglaterra, España y Argentina. Después de casi 20 años de catering, decidí ofrecer lo mejor de nuestra cocina: el asado. Nuestros cortes, nuestra técnica, nuestra cultura, nuestra pasión. ¡Viva el asado argentino!",
    },
    reviews: {
      overline: "Lo que dicen",
      title: "170+ reseñas · 4.99 ★",
      subtitle: "Huéspedes de todo el mundo compartieron nuestra mesa.",
    },
    location: {
      overline: "Dónde nos encontramos",
      title: "Asado en Palermo Soho, Buenos Aires",
      body:
        "Una casa íntima en el corazón de Palermo Soho. A diferencia de las parrillas del barrio, acá los asados en Palermo se viven puertas adentro: mesa chica, fuego a la vista y sobremesa sin apuro. La dirección exacta se comparte al confirmar la reserva. La experiencia se realiza en español, inglés y portugués.",
      neighborhood: "Palermo Soho · C1414 · Buenos Aires, Argentina",
      hours: "Lunes a Sábado · 13:00–15:30 · 19:30–22:00 · ~2.5h",
      capacity: "1 – 10 personas por reserva",
      languages: "Español · Inglés · Português",
    },
    faq: {
      overline: "Preguntas frecuentes",
      title: "Lo que necesitás saber",
      items: [
        {
          q: "¿Dónde comer un asado en Palermo?",
          a: "Asado Xperience recibe en una casa íntima de Palermo Soho, Buenos Aires (C1414), de lunes a sábado al mediodía o a la noche. No es una parrilla de salón: son asados en Palermo puertas adentro, para mesas de 1 a 10 personas, con Diego cocinando a la vista y clase de asado incluida.",
        },
        {
          q: "¿Qué diferencia hay entre este asado en Palermo y una parrilla del barrio?",
          a: "En una parrilla pedís por carta y comés. Acá compartís las 2.5 horas completas del ritual: recepción con Malbec, clase de asado junto a la brasa, provoleta y choripán, tres cortes premium, postre y café. USD 65 por persona, todo incluido.",
        },
        {
          q: "¿Qué incluye la experiencia?",
          a: "Malbec de bienvenida, provoleta, choripán, vegetales a la parrilla, matambre de cerdo, ojo de bife, asado de tira, postre y café. Duración aproximada: 2.5 horas.",
        },
        {
          q: "¿Cuál es la política de cancelación?",
          a: "Podés cancelar con al menos 24 horas de anticipación para recibir reembolso completo.",
        },
        {
          q: "¿Hay opciones vegetarianas?",
          a: "Sí, podemos adaptar el menú con vegetales y provoleta. Avisanos en las notas de tu reserva.",
        },
        {
          q: "¿Es apto para niños?",
          a: "Sí, los niños desde 2 años son bienvenidos.",
        },
        {
          q: "¿En qué idiomas se realiza?",
          a: "La experiencia se realiza en español, inglés y portugués.",
        },
        {
          q: "¿Cuánto cuesta la experiencia?",
          a: "USD 65 por persona. El precio incluye el Malbec de bienvenida, las entradas, todos los cortes, los acompañamientos, el postre y el café: no hay costos adicionales.",
        },
        {
          q: "¿Cuánto dura y en qué horarios se realiza?",
          a: "Dura aproximadamente 2.5 horas. Podés elegir almuerzo (13:00 a 15:30) o cena (19:30 a 22:00), de lunes a sábado.",
        },
        {
          q: "¿Dónde queda exactamente?",
          a: "En una casa íntima de Palermo Soho, Buenos Aires (C1414). La dirección exacta se comparte al confirmar la reserva, para cuidar la privacidad del anfitrión y de cada mesa.",
        },
        {
          q: "¿Cuántas personas pueden participar?",
          a: "Desde 1 hasta 10 personas por reserva. Es una mesa íntima: si sos un grupo grande, escribinos antes para coordinar la fecha.",
        },
        {
          q: "¿Cómo reservo y cómo se paga?",
          a: "Elegís fecha y horario en el formulario y lo mandás por WhatsApp o por email, como prefieras. En los dos casos Diego confirma la disponibilidad y coordina el pago con vos. Si lo mandás por email, te llega una copia del pedido a tu casilla.",
        },
      ],
    },
    booking: {
      overline: "Reservar",
      title: "Asegurá tu lugar en la mesa",
      subtitle: "USD 65 en Buenos Aires · USD 100 en Miami · Coordinás la reserva por WhatsApp o por email",
      place_label: "Sede",
      place_wa: "Sede",
      places: {
        argentina: { tab: "Reserva Argentina", place: "Palermo Soho · Buenos Aires", price: 65, wa: "🇦🇷 Argentina — Palermo Soho, Buenos Aires", phone: "+54 11 1234 5678" },
        miami: { tab: "Reserva Miami", place: "Miami · Florida, EE. UU.", price: 100, wa: "🇺🇸 Miami — Florida, EE. UU.", phone: "+1 305 123 4567" },
      },
      name: "Nombre completo",
      email: "Email",
      phone: "Teléfono (WhatsApp)",
      guests: "Personas",
      date: "Fecha",
      time: "Horario",
      notes: "Notas (restricciones, idioma, etc.)",
      total: "Total",
      submit: "Reservar por WhatsApp",
      submit_email: "Reservar por email",
      sending: "Enviando…",
      email_required: "Para reservar por email necesitamos tu dirección.",
      email_note: "¿No usás WhatsApp? Mandá el pedido por email: te llega el resumen a tu casilla y Diego te responde desde la suya.",
      sent_title: "Recibimos tu pedido",
      sent_body: "Te mandamos el resumen a __EMAIL__. Diego confirma la disponibilidad y coordina el pago; tu lugar todavía no está reservado.",
      sent_spam: "Si en unos minutos no lo ves, mirá en spam o promociones.",
      sent_no_email: "Tu pedido le llegó a Diego, pero no pudimos mandarte la copia a __EMAIL__. Revisá que la dirección esté bien escrita.",
      sent_ref: "Código de tu pedido",
      sent_again: "Hacer otro pedido",
      sent_whatsapp: "Escribirle por WhatsApp",
      whatsapp_note: "Al reservar se abre WhatsApp con tu pedido listo para enviar a Diego, que confirma disponibilidad y coordina el pago.",
      pick_date: "Elegí una fecha",
      pick_slot: "Elegí un horario",
      slot_lunch: "Almuerzo (13:00 – 15:30)",
      slot_dinner: "Cena (19:30 – 22:00)",
      wa_greeting: "¡Hola Diego! Quiero reservar Asado Xperience 🔥",
      success_title: "¡Reserva confirmada!",
      success_body:
        "Te enviamos un email con los detalles. Nos vemos pronto en Palermo Soho.",
      cancelled_title: "Pago cancelado",
      cancelled_body: "Podés intentarlo de nuevo cuando quieras.",
      back_home: "Volver al inicio",
    },
    palermo: {
      seo_title: "Experiencia de asado en Palermo Soho: menú, precio y horarios",
      seo_description:
        "Qué incluye la experiencia de asado argentino en Palermo Soho: los cinco momentos del menú, USD 65 por persona, 2.5 h de lunes a sábado y cómo reservar con Diego.",
      hero_overline: "Palermo Soho · Buenos Aires",
      hero_title_1: "Experiencia de asado",
      hero_title_2: "en Palermo Soho.",
      hero_subtitle:
        "Una auténtica cena argentina alrededor del fuego: cortes premium, Malbec y una mesa íntima en el corazón de Buenos Aires.",
      hero_cta: "Reservar experiencia",
      intro_overline: "Una noche argentina",
      intro_title: "Más que una cena: una forma de encontrarnos.",
      intro_p1:
        "Si buscás un asado en Palermo que vaya más allá de sentarte a comer, esta experiencia es para vos. Durante aproximadamente dos horas y media, Diego te recibe en una casa íntima de Palermo Soho y te invita a conocer los rituales, los sabores y las historias que hacen del asado argentino una parte esencial de nuestra cultura.",
      intro_p2:
        "La noche comienza con una copa de Malbec mientras el fuego toma temperatura. Después llegan la provoleta, el choripán artesanal, los vegetales a la parrilla y una selección de cortes premium preparados sin apuro. La conversación ocurre alrededor de la brasa: podés preguntar, acercarte a la parrilla y aprender las técnicas que Diego construyó durante más de 20 años de catering.",
      intro_p3:
        "Es una experiencia gastronómica en Buenos Aires pensada para quienes quieren comer como locales y llevarse algo más: el recuerdo de una mesa compartida, una historia sobre Argentina y el sabor de un asado hecho con tiempo.",
      menu_overline: "Menú del asado argentino",
      menu_title: "Cinco momentos alrededor de la brasa.",
      menu_items: [
        ["01", "Recepción con Malbec", "Una copa para brindar, conocernos y dejar que empiece la sobremesa."],
        ["02", "Provoleta y entradas", "Provoleta fundida, choripán artesanal y vegetales preparados a la parrilla."],
        ["03", "La clase de asado", "Técnicas, cortes, tiempos y la historia detrás del ritual más argentino."],
        ["04", "Cortes premium", "Matambre de cerdo, ojo de bife y asado de tira, servidos sin apuro."],
        ["05", "Postre y café", "Panqueque con dulce de leche y espresso para cerrar la noche."],
      ],
      details_overline: "Información útil",
      details_title: "Palermo Soho como punto de encuentro.",
      details_body:
        "La experiencia sucede en una casa íntima en Palermo Soho, uno de los barrios más vibrantes de Buenos Aires. La dirección exacta se comparte al confirmar la reserva, para cuidar la privacidad del anfitrión y de cada mesa.",
      details_location: "Palermo Soho · Buenos Aires, Argentina",
      details_hours: "Lunes a sábado · almuerzo o cena · duración aproximada 2.5 h",
      details_capacity: "De 1 a 10 personas · español, inglés y portugués",
      details_price: "USD 65 por persona · reservas coordinadas por WhatsApp",
      ig_overline: "Desde Instagram",
      ig_title: "El fuego también se comparte.",
      ig_body:
        "Mirá el día a día de Asado Xperience, los cortes, la parrilla y las mesas que compartimos en Palermo Soho.",
      cta_overline: "Tu lugar en la mesa",
      cta_title: "¿Listo para vivir un asado en Palermo?",
      cta_body:
        "Elegí una fecha y escribile a Diego. Él confirma disponibilidad y coordina todos los detalles de tu experiencia.",
      cta_button: "Reservar tu lugar",
      gallery_label: "Galería de la experiencia de asado",
      gallery_prev: "Imagen anterior",
      gallery_next: "Siguiente imagen",
      gallery_alts: [
        "Asado argentino cocinándose a la brasa en Palermo Soho",
        "Cortes premium preparados en una parrilla argentina",
        "Mesa íntima de una experiencia gastronómica en Buenos Aires",
        "Cocina al fuego de una experiencia de asado argentino",
      ],
      hero_alt: "Experiencia de asado argentino en Palermo Soho, Buenos Aires",
    },
    curso: {
      seo_title: "Curso de parrillero argentino en Buenos Aires: aprendé a hacer asado",
      seo_description:
        "Curso de parrillero 100% práctico en Palermo Soho y Miami: domá el fuego, elegí los cortes, hacé el chimichurri y serví un auténtico asado argentino. USD 200 por persona.",
      hero_overline: "Curso práctico · Palermo Soho",
      hero_title_1: "Curso de parrillero",
      hero_title_2: "argentino.",
      hero_subtitle: "Aprendé a hacer un auténtico asado argentino, del fuego a la mesa.",
      hero_cta: "Reservar mi lugar",
      hero_alt: "Alumna del curso de parrillero dando vuelta la carne sobre las brasas en Palermo Soho",
      intro_overline: "Del fuego a la mesa",
      intro_title: "Acá no venís a mirar. Venís a hacer el asado.",
      intro_p1:
        "¿Te apasiona la parrilla y querés aprender de verdad cómo se hace un auténtico asado argentino?",
      intro_p2:
        "Este curso es una experiencia 100% práctica en la que vas a estar frente a la parrilla, trabajando con el fuego, preparando los cortes y aprendiendo las técnicas que usamos los parrilleros argentinos.",
      intro_p3:
        "Lo dicta Diego, parrillero con casi 20 años de catering, en una casa de Palermo Soho y en grupos reducidos, para que cada uno tenga su lugar junto a la brasa.",
      learn_overline: "¿Qué vas a aprender?",
      learn_title: "Seis técnicas del parrillero argentino.",
      learn_items: [
        ["01", "Domar el fuego", "Aprendé a encender y manejar el carbón y la leña, controlar el calor y conseguir la brasa perfecta."],
        ["02", "Preparar la parrilla", "Descubrí cómo organizar el fuego y las diferentes zonas de cocción para trabajar varios cortes al mismo tiempo."],
        ["03", "Chimichurri & salsa criolla", "Prepará desde cero las dos salsas clásicas que no pueden faltar en un verdadero asado argentino."],
        ["04", "Elegir y preparar los cortes", "Aprendé qué buscar al comprar carne, cómo preparar cada corte y qué tipo de sal utilizar."],
        ["05", "Temperatura, altura y tiempos", "Aprendé a manejar el calor de la parrilla y a reconocer cuándo cada corte está listo."],
        ["06", "Punto, reposo y servicio", "Descubrí cómo conseguir el punto que buscás, dejar descansar correctamente la carne y cortarla y servirla para conservar todos sus jugos."],
      ],
      details_overline: "Información útil",
      details_title: "Un curso frente a la parrilla.",
      details_body:
        "El curso se dicta en Buenos Aires, en una casa de Palermo Soho, y también en Miami. La dirección exacta se comparte al confirmar tu lugar.",
      details_location: "Palermo Soho, Buenos Aires · Miami, EE. UU.",
      details_format: "100% práctico · vos hacés el asado, de principio a fin",
      details_capacity: "Grupos reducidos · español, inglés y portugués",
      details_price: "USD 200 por persona · fechas a coordinar con Diego por WhatsApp",
      cta_overline: "Tu lugar en la parrilla",
      cta_title: "¿Listo para hacer tu primer asado de verdad?",
      cta_body:
        "Elegí dónde querés hacer el curso y completá tus datos: se abre WhatsApp con tu pedido listo para enviarle a Diego, que te confirma la fecha y tu lugar.",
      form_place_label: "¿Dónde querés hacer el curso?",
      form_places: {
        argentina: { tab: "Reserva Argentina", place: "Palermo Soho · Buenos Aires", wa: "🇦🇷 Argentina — Palermo Soho, Buenos Aires", phone: "+54 11 1234 5678" },
        miami: { tab: "Reserva Miami", place: "Miami · Florida, EE. UU.", wa: "🇺🇸 Miami — Florida, EE. UU.", phone: "+1 305 123 4567" },
      },
      form_place_wa: "Sede",
      form_price_overline: "Precio del curso",
      form_price_per_guest: "USD 200 por persona",
      form_price_note: "Mismo precio en Argentina y en Miami.",
      form_date: "Fecha preferida (opcional)",
      form_message: "Mensaje (opcional)",
      form_message_placeholder: "Experiencia previa, alergias, preguntas...",
      form_submit: "Enviar por WhatsApp",
      form_note: "Al enviar se abre WhatsApp con tu pedido listo. Tu lugar se confirma cuando Diego te responde y coordinan el pago.",
      form_email_note: "¿No usás WhatsApp? Mandá el pedido por email: te llega el resumen a tu casilla y Diego te responde desde la suya.",
      form_name_required: "Ingresá tu nombre",
      wa_greeting: "¡Hola Diego! Quiero reservar el Curso de Parrillero Argentino 🔥",
      learn_alts: [
        "Carbón y leña encendidos en la parrilla, listos para hacer brasa",
        "Alumno del curso de parrillero acomodando las brasas bajo la parrilla",
        "Chimichurri casero junto a los frascos de especias",
        "Cortes de carne crudos, chorizos y sal gruesa antes de ir a la parrilla",
        "Alumna del curso controlando los cortes sobre la parrilla",
        "Diego mostrando un corte a la mesa antes de servirlo",
      ],
      gallery_alts: [
        "Diego enseñándole a una alumna a manejar la parrilla",
        "Grupo del curso de parrillero alrededor de la parrilla en Palermo Soho",
        "Alumnos trabajando juntos frente al fuego durante el curso",
        "Alumno del curso mostrando un corte recién preparado",
      ],
    },
    footer: {
      tagline: "Asado · tradición · experiencia única",
      rights: "Todos los derechos reservados.",
      explore: "Explorá",
      palermo_link: "Experiencia de asado en Palermo Soho",
      curso_link: "Curso de parrillero argentino",
      international: "Para reservas internacionales",
      international_modal_title: "Reservas internacionales",
      international_modal_desc:
        "Escaneá el código QR con tu teléfono para reservar tu experiencia desde el exterior.",
    },
    common: { loading: "Cargando...", error: "Error" },
  },
  en: {
    nav: {
      experience: "Experience",
      menu: "Menu",
      host: "Host",
      reviews: "Reviews",
      location: "Location",
      book: "Book now",
      admin: "Admin",
      home: "Home",
      faq: "FAQ",
      pages: "Pages",
      sections: "The experience",
      open_menu: "Open menu",
      close_menu: "Close menu",
      whatsapp: "Message us on WhatsApp",
    },
    hero: {
      overline: "Palermo Soho · Buenos Aires",
      title_1: "Argentine asado",
      title_2: "in Palermo Soho.",
      subtitle:
        "Join Diego for an authentic Argentine asado: embers, Malbec and premium cuts around an intimate table in Palermo Soho.",
      cta: "Book the experience",
      secondary: "Discover the menu",
      rating_caption: "170+ reviews · 4.99 avg",
    },
    experience: {
      overline: "The experience",
      title: "Five moments. One unforgettable night.",
      subtitle:
        "A 2.5-hour journey through the rituals of Argentine asado — from the Malbec welcome to the sweet ending.",
      steps: [
        {
          title: "Welcome with Malbec",
          body:
            "We greet you with a glass of our aged Malbec. Conversation begins, the pace slows down, the embers are lit.",
        },
        {
          title: "Asado masterclass",
          body:
            "Diego shares tips, techniques, history and culture of the asado. Join him at the grill for every cut.",
        },
        {
          title: "Provoleta & starters",
          body:
            "Provoleta melted to the perfect point, artisan choripán and grilled vegetables.",
        },
        {
          title: "The cuts",
          body:
            "Matambre de cerdo, ojo de bife and asado de tira. All the accompaniments, served without rush.",
        },
        {
          title: "Dessert & coffee",
          body: "Panqueque with dulce de leche paired with espresso. A calm, long sobremesa.",
        },
      ],
    },
    host: {
      overline: "Your host",
      title: "Diego",
      tagline: "Argentine barbecue specialist · 20 years of catering",
      body:
        "I have lived in Venezuela, Mexico, England, Spain and Argentina. After nearly 20 years in catering, I decided to offer the best of our cuisine: the asado. Our cuts, our technique, our culture, our passion. Long live the Argentine asado!",
    },
    reviews: {
      overline: "What guests say",
      title: "170+ reviews · 4.99 ★",
      subtitle: "Guests from all over the world joined our table.",
    },
    location: {
      overline: "Where we meet",
      title: "Asado in Palermo Soho, Buenos Aires",
      body:
        "An intimate house in the heart of Palermo Soho. Unlike the steakhouses around the corner, an asado in Palermo happens here behind closed doors: a small table, the fire in plain sight and a long, unhurried sobremesa. The exact address is shared upon confirming your booking. The experience is hosted in Spanish, English and Portuguese.",
      neighborhood: "Palermo Soho · C1414 · Buenos Aires, Argentina",
      hours: "Monday to Saturday · 13:00–15:30 · 19:30–22:00 · ~2.5h",
      capacity: "1 – 10 guests per booking",
      languages: "Spanish · English · Português",
    },
    faq: {
      overline: "FAQ",
      title: "Things to know",
      items: [
        {
          q: "Where can I eat an asado in Palermo?",
          a: "Asado Xperience hosts in an intimate home in Palermo Soho, Buenos Aires (C1414), Monday to Saturday for lunch or dinner. It is not a steakhouse: it is an asado in Palermo behind closed doors, for tables of 1 to 10 guests, with Diego cooking in front of you and a grilling class included.",
        },
        {
          q: "How is this different from a Palermo steakhouse?",
          a: "At a parrilla you order from a menu and eat. Here you share the full 2.5-hour ritual: welcome Malbec, an asado class by the embers, provoleta and choripán, three premium cuts, dessert and coffee. USD 65 per person, all included.",
        },
        {
          q: "What's included?",
          a: "Welcome Malbec, provoleta, choripán, grilled vegetables, matambre de cerdo, ojo de bife, asado de tira, dessert and coffee. Duration ~2.5h.",
        },
        {
          q: "Cancellation policy?",
          a: "Cancel at least 24 hours before the start time for a full refund.",
        },
        {
          q: "Any vegetarian options?",
          a: "Yes — we can adapt the menu with vegetables and provoleta. Mention it in the booking notes.",
        },
        {
          q: "Kid-friendly?",
          a: "Yes. Guests ages 2 and up are welcome.",
        },
        {
          q: "Languages?",
          a: "The experience is hosted in Spanish, English and Portuguese.",
        },
        {
          q: "How much does the experience cost?",
          a: "USD 65 per person. The price covers the welcome Malbec, the starters, every cut, the sides, dessert and coffee — there are no extra charges.",
        },
        {
          q: "How long is it and what times are available?",
          a: "It runs for around 2.5 hours. You can choose lunch (1:00 to 3:30 pm) or dinner (7:30 to 10:00 pm), Monday through Saturday.",
        },
        {
          q: "Where exactly does it take place?",
          a: "In an intimate home in Palermo Soho, Buenos Aires (C1414). The exact address is shared once your booking is confirmed, to protect the privacy of the host and of every table.",
        },
        {
          q: "How many people can join?",
          a: "From 1 to 10 guests per booking. It is an intimate table, so if you are a larger group, message us in advance to arrange a date.",
        },
        {
          q: "How do I book and how do I pay?",
          a: "Pick a date and time in the form and send it over WhatsApp or by email, whichever you prefer. Either way Diego confirms availability and arranges payment with you. If you send it by email, a copy of the request lands in your inbox.",
        },
      ],
    },
    booking: {
      overline: "Book",
      title: "Secure your seat at the table",
      subtitle: "USD 65 in Buenos Aires · USD 100 in Miami · Arrange the booking on WhatsApp or by email",
      place_label: "Location",
      place_wa: "Location",
      places: {
        argentina: { tab: "Book in Argentina", place: "Palermo Soho · Buenos Aires", price: 65, wa: "🇦🇷 Argentina — Palermo Soho, Buenos Aires", phone: "+54 11 1234 5678" },
        miami: { tab: "Book in Miami", place: "Miami · Florida, USA", price: 100, wa: "🇺🇸 Miami — Florida, USA", phone: "+1 305 123 4567" },
      },
      name: "Full name",
      email: "Email",
      phone: "Phone (WhatsApp)",
      guests: "Guests",
      date: "Date",
      time: "Time",
      notes: "Notes (dietary, language, etc.)",
      total: "Total",
      submit: "Book via WhatsApp",
      submit_email: "Book via email",
      sending: "Sending…",
      email_required: "We need your email address to book by email.",
      email_note: "Not on WhatsApp? Send the request by email instead: you get the summary in your inbox and Diego replies from his.",
      sent_title: "We got your request",
      sent_body: "We sent the summary to __EMAIL__. Diego will confirm availability and arrange payment; your seat is not booked yet.",
      sent_spam: "If it does not show up in a few minutes, check your spam or promotions folder.",
      sent_no_email: "Your request reached Diego, but we could not send your copy to __EMAIL__. Double-check the address.",
      sent_ref: "Your request code",
      sent_again: "Send another request",
      sent_whatsapp: "Message him on WhatsApp",
      whatsapp_note: "Booking opens WhatsApp with your request ready to send to Diego, who confirms availability and arranges payment.",
      pick_date: "Pick a date",
      pick_slot: "Pick a time",
      slot_lunch: "Lunch (13:00 – 15:30)",
      slot_dinner: "Dinner (19:30 – 22:00)",
      wa_greeting: "Hi Diego! I'd like to book Asado Xperience 🔥",
      success_title: "Booking confirmed!",
      success_body: "We sent you an email with the details. See you soon in Palermo Soho.",
      cancelled_title: "Payment cancelled",
      cancelled_body: "You can try again whenever you want.",
      back_home: "Back to home",
    },
    palermo: {
      seo_title: "Asado Experience in Palermo Soho: menu, price and times",
      seo_description:
        "Join an authentic Argentine asado experience in Palermo Soho: premium cuts, Malbec and an intimate dinner around the fire with Diego. USD 65 per person.",
      hero_overline: "Palermo Soho · Buenos Aires",
      hero_title_1: "Argentine asado experience",
      hero_title_2: "in Palermo Soho.",
      hero_subtitle:
        "An authentic Argentine dinner around the fire: premium cuts, Malbec and an intimate table in the heart of Buenos Aires.",
      hero_cta: "Book the experience",
      intro_overline: "An Argentine night",
      intro_title: "More than dinner: a way of coming together.",
      intro_p1:
        "If you are looking for an asado in Palermo that goes beyond simply sitting down to eat, this experience is for you. Over roughly two and a half hours, Diego welcomes you into an intimate home in Palermo Soho and walks you through the rituals, flavours and stories that make the Argentine asado a cornerstone of our culture.",
      intro_p2:
        "The night opens with a glass of Malbec while the fire comes up to temperature. Then come the provoleta, the handmade choripán, the grilled vegetables and a selection of premium cuts cooked without rushing. The conversation happens around the embers: you can ask questions, step up to the grill and learn the techniques Diego built over more than 20 years in catering.",
      intro_p3:
        "It is a food experience in Buenos Aires made for travellers who want to eat like locals and take home something more: the memory of a shared table, a story about Argentina and the taste of an asado cooked slowly.",
      menu_overline: "The Argentine asado menu",
      menu_title: "Five moments around the embers.",
      menu_items: [
        ["01", "Malbec welcome", "A glass to toast, get to know each other and let the evening begin."],
        ["02", "Provoleta and starters", "Melted provoleta, handmade choripán and vegetables cooked on the grill."],
        ["03", "The asado class", "Techniques, cuts, timing and the history behind Argentina's most beloved ritual."],
        ["04", "Premium cuts", "Pork matambre, ribeye and short ribs, served without rushing."],
        ["05", "Dessert and coffee", "Crêpe with dulce de leche and espresso to close the night."],
      ],
      details_overline: "Useful information",
      details_title: "Palermo Soho as the meeting point.",
      details_body:
        "The experience takes place in an intimate home in Palermo Soho, one of the most vibrant neighbourhoods in Buenos Aires. The exact address is shared once your booking is confirmed, to protect the privacy of the host and of every table.",
      details_location: "Palermo Soho · Buenos Aires, Argentina",
      details_hours: "Monday to Saturday · lunch or dinner · around 2.5 hours",
      details_capacity: "1 to 10 guests · Spanish, English and Portuguese",
      details_price: "USD 65 per person · bookings arranged over WhatsApp",
      ig_overline: "From Instagram",
      ig_title: "The fire is meant to be shared.",
      ig_body:
        "See the day to day of Asado Xperience: the cuts, the grill and the tables we share in Palermo Soho.",
      cta_overline: "Your seat at the table",
      cta_title: "Ready for an asado in Palermo?",
      cta_body:
        "Pick a date and message Diego. He confirms availability and arranges every detail of your experience.",
      cta_button: "Book your seat",
      gallery_label: "Asado experience gallery",
      gallery_prev: "Previous image",
      gallery_next: "Next image",
      gallery_alts: [
        "Argentine asado cooking over the embers in Palermo Soho",
        "Premium cuts prepared on an Argentine grill",
        "Intimate table at a food experience in Buenos Aires",
        "Open fire cooking at an Argentine asado experience",
      ],
      hero_alt: "Argentine asado experience in Palermo Soho, Buenos Aires",
    },
    curso: {
      seo_title: "Argentine Asado Class in Buenos Aires: Learn to Grill Like a Local",
      seo_description:
        "A 100% hands-on Argentine asado class in Palermo Soho and Miami: master the fire, pick the cuts, make chimichurri and serve a real asado. USD 200 per person.",
      hero_overline: "Hands-on class · Palermo Soho",
      hero_title_1: "Argentine asado",
      hero_title_2: "grill master class.",
      hero_subtitle: "Learn to make an authentic Argentine asado, from the fire to the table.",
      hero_cta: "Book my spot",
      hero_alt: "Asado class student turning the meat over the embers in Palermo Soho",
      intro_overline: "From fire to table",
      intro_title: "You don't come here to watch. You come to cook the asado.",
      intro_p1:
        "Passionate about grilling and want to truly learn how an authentic Argentine asado is made?",
      intro_p2:
        "This class is a 100% hands-on experience: you'll stand at the grill, work the fire, prepare the cuts and learn the techniques we Argentine parrilleros use.",
      intro_p3:
        "It is taught by Diego, a grill master with almost 20 years in catering, in a home in Palermo Soho and in small groups, so everyone gets their place by the embers.",
      learn_overline: "What will you learn?",
      learn_title: "Six skills of the Argentine grill master.",
      learn_items: [
        ["01", "Master the fire", "Learn to light and handle charcoal and firewood, control the heat and get the perfect embers."],
        ["02", "Set up the grill", "Discover how to arrange the fire and the different cooking zones to work several cuts at the same time."],
        ["03", "Chimichurri & salsa criolla", "Make from scratch the two classic sauces no true Argentine asado can go without."],
        ["04", "Choose and prepare the cuts", "Learn what to look for when buying meat, how to prepare each cut and which salt to use."],
        ["05", "Heat, height and timing", "Learn to manage the heat of the grill and to recognise when each cut is ready."],
        ["06", "Doneness, resting and serving", "Discover how to hit the doneness you want, rest the meat properly, and carve and serve it so it keeps all its juices."],
      ],
      details_overline: "Useful information",
      details_title: "A class at the grill.",
      details_body:
        "The class is taught in Buenos Aires, in a home in Palermo Soho, and also in Miami. The exact address is shared once your spot is confirmed.",
      details_location: "Palermo Soho, Buenos Aires · Miami, USA",
      details_format: "100% hands-on · you cook the asado, start to finish",
      details_capacity: "Small groups · Spanish, English and Portuguese",
      details_price: "USD 200 per person · dates arranged with Diego on WhatsApp",
      cta_overline: "Your spot at the grill",
      cta_title: "Ready to cook your first real asado?",
      cta_body:
        "Choose where you want to take the class and fill in your details: WhatsApp opens with your request ready to send to Diego, who confirms the date and your spot.",
      form_place_label: "Where do you want to take the class?",
      form_places: {
        argentina: { tab: "Book in Argentina", place: "Palermo Soho · Buenos Aires", wa: "🇦🇷 Argentina — Palermo Soho, Buenos Aires", phone: "+54 11 1234 5678" },
        miami: { tab: "Book in Miami", place: "Miami · Florida, USA", wa: "🇺🇸 Miami — Florida, USA", phone: "+1 305 123 4567" },
      },
      form_place_wa: "Location",
      form_price_overline: "Class price",
      form_price_per_guest: "USD 200 per person",
      form_price_note: "Same price in Argentina and in Miami.",
      form_date: "Preferred date (optional)",
      form_message: "Message (optional)",
      form_message_placeholder: "Previous experience, allergies, questions...",
      form_submit: "Send via WhatsApp",
      form_note: "WhatsApp opens with your request ready to send. Your spot is confirmed once Diego replies and you arrange payment.",
      form_email_note: "Don't use WhatsApp? Send the request by email: you get a copy in your inbox and Diego replies from his.",
      form_name_required: "Enter your name",
      wa_greeting: "Hi Diego! I'd like to book the Argentine asado class 🔥",
      learn_alts: [
        "Charcoal and firewood burning in the grill, getting ready to make embers",
        "Asado class student arranging the embers under the grill",
        "Homemade chimichurri next to jars of spices",
        "Raw cuts of beef, chorizos and coarse salt before going on the grill",
        "Asado class student checking the cuts on the grill",
        "Diego showing a cut to the table before serving it",
      ],
      gallery_alts: [
        "Diego teaching a student how to work the grill",
        "Asado class group around the grill in Palermo Soho",
        "Students working together at the fire during the class",
        "Asado class student holding up a freshly prepared cut",
      ],
    },
    footer: {
      tagline: "Asado · tradition · unique experience",
      rights: "All rights reserved.",
      explore: "Explore",
      palermo_link: "Asado experience in Palermo Soho",
      curso_link: "Argentine asado class",
      international: "For international bookings",
      international_modal_title: "International bookings",
      international_modal_desc:
        "Scan the QR code with your phone to book your experience from abroad.",
    },
    common: { loading: "Loading...", error: "Error" },
  },
};
